import { useSyncExternalStore } from 'react';
import { MutationKey } from '@tanstack/react-query';

const counts = new Map<string, number>();
const listeners = new Set<() => void>();
let revision = 0;

function snapshot(): number {
	return revision;
}

function notify() {
	revision += 1;
	listeners.forEach((listener) => listener());
}

function keyFor(mutationKey: MutationKey): string {
	return JSON.stringify(mutationKey);
}

export function markMutationPending(mutationKey: MutationKey): void {
	const key = keyFor(mutationKey);
	counts.set(key, (counts.get(key) ?? 0) + 1);
	notify();
}

export function unmarkMutationPending(mutationKey: MutationKey): void {
	const key = keyFor(mutationKey);
	const current = counts.get(key) ?? 0;
	if (current <= 1) {
		counts.delete(key);
	} else {
		counts.set(key, current - 1);
	}
	notify();
}

function subscribe(listener: () => void): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

export function useIsMutationPending(mutationKeys: MutationKey[]): number {
	useSyncExternalStore(subscribe, snapshot, snapshot);
	let total = 0;
	for (const key of mutationKeys) {
		total += counts.get(keyFor(key)) ?? 0;
	}
	return total;
}
